// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewCard_root__A8Zh_","top":"ReviewCard_top__mYRe2","heading":"ReviewCard_heading__40Je9","description":"ReviewCard_description__RvhfX","name":"ReviewCard_name__JyHoM"};